module.exports = __webpack_public_path__ + "media/images/home/flow_r_index_1-f1c120373bc33f836604edcc92d1945c.svg";